// extracted by mini-css-extract-plugin
export default {"projectsFeaturesCard":"projectsFeaturesCard_projectsFeaturesCard__JkOHV","name":"projectsFeaturesCard_name__lrmWq"};